import { useParams, useSearch } from '@tanstack/react-router'

export type ChatFocus = {
	entity_type: 'campaign' | 'person'
	entity_id: string
}

/**
 * Derives Jobibot's ambient focus from where the user currently is:
 * a peeked talent-pool person wins over a campaign page. Sent with every
 * message; the backend keeps the last focus when this is null.
 */
export function useCurrentFocus(): ChatFocus | null {
	const { campaignId } = useParams({ strict: false }) as { campaignId?: string }
	const { peek } = useSearch({ strict: false }) as { peek?: string }

	if (peek) {
		return { entity_type: 'person', entity_id: peek }
	}

	if (campaignId) {
		return { entity_type: 'campaign', entity_id: campaignId }
	}

	return null
}
